// extracted by mini-css-extract-plugin
module.exports = {"light":"#EAE9E8","timeline":"TimelineGraph_timeline__3La_N","yGrid":"TimelineGraph_yGrid__3ewZA"};